/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

type Props = {
  rootClassName?: string;
  'data-e2e'?: string;
  label: React.ReactChild;
  textColor: string;
  backgroundColor: string;
};

export const Pill = (props: Props) => {
  const { rootClassName, label, textColor, backgroundColor, ...otherProps } = props;

  return (
    <div
      className={`rc-Pill ${rootClassName}`}
      data-e2e={otherProps['data-e2e']}
      css={css`
        background-color: ${backgroundColor};
        padding: var(--cds-spacing-50);
        width: fit-content;
        border-radius: 4px;
      `}
    >
      <Typography2 component="span" variant="subtitleMedium" style={{ color: textColor }}>
        {label}
      </Typography2>
    </div>
  );
};

export const LivePill = () => {
  return (
    <Pill
      label={['•', _t('Live Now')].join(' ')}
      textColor="var(--cds-color-red-750)"
      backgroundColor="var(--cds-color-red-50)"
    />
  );
};

export default Pill;
